module.exports = __webpack_public_path__ + "static/media/logo.51df25fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/citylink/logo.svg
// module id = 161
// module chunks = 0